import Chart from 'react-apexcharts'

const GroupStackedColumnChart = ({
  chartId,
  xaxis,
  earlyApplicantsArray,
  earlyAdmitArray,
  regularApplicantsArray,
  regularAdmitArray,
}) => {
  const filterDataWithCategories = (
    arrays: number[][],
    categories: string[]
  ): {
    filteredArrays: number[][],
    filteredCategories: string[]
  } => {
    const length = arrays[0]?.length || 0;
    const filteredArrays: number[][] = arrays.map(() => []);
    const filteredCategories: string[] = [];

    for (let i = 0; i < length; i++) {
      const valuesAtIndex = arrays.map((arr) => arr[i]);
      const hasValidValue = valuesAtIndex.some(
        (val) => val != null && val !== 0
      );

      if (hasValidValue) {
        valuesAtIndex.forEach((val, idx) => {
          filteredArrays[idx].push(val);
        });
        filteredCategories.push(categories[i]);
      }
    }

    return { filteredArrays, filteredCategories };
  };

  const {
    filteredArrays: [
      filteredEarlyApplicants,
      filteredEarlyAdmits,
      filteredRegularApplicants,
      filteredRegularAdmits,
    ],
    filteredCategories: filteredXAxis,
  } = filterDataWithCategories(
    [earlyApplicantsArray, earlyAdmitArray, regularApplicantsArray, regularAdmitArray],
    xaxis
  );

  const yMax = Math.max(
    ...filteredEarlyApplicants,
    ...filteredEarlyAdmits,
    ...filteredRegularApplicants,
    ...filteredRegularAdmits
  ) + 5000;

  return (
    <Chart
      options={{
        chart: {
          id: chartId,
          stacked: true,
          toolbar: { show: false },
        },
        xaxis: {
          categories: filteredXAxis,
          labels: {
            show: true,
            rotate: -45,
            style: { colors: '#9AA2B6' },
          },
        },
        yaxis: {
          min: 0,
          forceNiceScale: true,
          labels: {
            style: { colors: ['#9AA2B6'] },
            formatter: (val) => val?.toLocaleString('en-US') ?? 'N/A',
          },
        },
        colors: ['#90F892', '#FFEF68', '#97E6FF', '#C5DEF9'],
        tooltip: { enabled: true },
        dataLabels: {
          enabled: true,
          style: { colors: ['#000000'] },
          background: {
            enabled: false,
            borderWidth: 0,
            foreColor: '#000',
          },
          formatter: (val) => val?.toLocaleString('en-US') ?? 'N/A',
        },
        legend: {
          show: true,
          onItemClick: { toggleDataSeries: false },
          onItemHover: { highlightDataSeries: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '75%',
            dataLabels: {
              position: 'top',
              total: { enabled: false },
            },
          },
        },
      }}
      series={[
        {
          name: 'Early Round Applicants',
          group: 'Applicants',
          data: filteredEarlyApplicants,
        },
        {
          name: 'Early Round Admits',
          group: 'Admits',
          data: filteredEarlyAdmits,
        },
        {
          name: 'Regular Round Applicants',
          group: 'Applicants',
          data: filteredRegularApplicants,
        },
        {
          name: 'Regular Round Admits',
          group: 'Admits',
          data: filteredRegularAdmits,
        },
      ]}
      type="bar"
      height={'300'}
    />
  );
};

// const GroupStackedColumnChart = ({ chartId, xaxis, earlyApplicantsArray, earlyAdmitArray, regularApplicantsArray, regularAdmitArray }) => {

//   const yMax = Math.max(
//     ...earlyApplicantsArray,
//     ...earlyAdmitArray,
//     ...regularApplicantsArray,
//     ...regularAdmitArray
//   ) + 5000

//   return (
//     <Chart
//       options={{
//         chart: {
//           id: chartId,
//           stacked: true,
//           toolbar: {
//             show: false,
//           },
//         },
//         xaxis: {
//           categories: xaxis,
//           labels: {
//             show: true,
//             rotate: -45,
//             style: {
//               colors: '#9AA2B6',
//             },
//           }
//         },
//         yaxis: {
//           min: 0,
//           //max: yMax,
//           forceNiceScale: true,
//           labels: {
//             style: {
//               colors: ['#9AA2B6'],
//             },
//             formatter: function (val, opts) {
//               return val?.toLocaleString("en-US") ?? 'N/A';
//             },
//           }
//         },
//         //colors: ['#80c7fd', '#008FFB', '#80f1cb', '#00E396'],
//         colors: ["#90F892", "#FFEF68", "#97E6FF", "#C5DEF9"],
//         tooltip: {
//           enabled: true,
//         },
//         dataLabels: {
//           enabled: true,
//           style: {
//             colors: ['#000000'],
//           },
//           background: {
//             enabled: false,
//             borderWidth: 0,
//             foreColor: '#000',
//           },
//           formatter: function (val, opts) {
//             return val?.toLocaleString("en-US") ?? 'N/A';
//           },
//         },
//         legend: {
//           show: true,
//           onItemClick: {
//             toggleDataSeries: false
//           },
//           onItemHover: {
//             highlightDataSeries: true
//           },
//         },
//         plotOptions: {
//           bar: {
//             horizontal: false,
//             columnWidth: '75%',
//             dataLabels: {
//               position: 'top',
//               total: {
//                 enabled: false,
//               }
//             },
//           }
//         }
//       }}
//       series={[
//         {
//           name: 'Early Round Applicants',
//           group: 'Applicants',
//           data: earlyApplicantsArray
//         },
//         {
//           name: 'Early Round Admits',
//           group: 'Admits',
//           data: earlyAdmitArray,
//         },
//         {
//           name: 'Regular Round Applicants',
//           group: 'Applicants',
//           data: regularApplicantsArray
//         },
//         {
//           name: 'Regular Round Admits',
//           group: 'Admits',
//           data: regularAdmitArray
//         }
//       ]}
//       type='bar'
//       height={'300'}
//     />
//   )
// }

const GroupStackedColumnChartGender = ({
  chartId,
  xaxis,
  menAppliedArray,
  menAdmittedArray,
  womenAppliedArray,
  womenAdmittedArray,
  otherAppliedArray,
  otherAdmittedArray,
}: {
  chartId: string;
  xaxis: string[];
  menAppliedArray: number[];
  menAdmittedArray: number[];
  womenAppliedArray: number[];
  womenAdmittedArray: number[];
  otherAppliedArray: number[];
  otherAdmittedArray: number[];
}) => {

  const filterDataWithCategories = (
    arrays: number[][],
    categories: string[]
  ): {
    filteredArrays: number[][];
    filteredCategories: string[];
  } => {
    const length = arrays[0]?.length || 0;
    const filteredArrays: number[][] = arrays.map(() => []);
    const filteredCategories: string[] = [];

    for (let i = 0; i < length; i++) {
      const valuesAtIndex = arrays.map((arr) => arr[i]);
      const hasValidValue = valuesAtIndex.some(
        (val) => val != null && val !== 0
      );

      if (hasValidValue) {
        valuesAtIndex.forEach((val, idx) => {
          filteredArrays[idx].push(val);
        });
        filteredCategories.push(categories[i]);
      }
    }

    return { filteredArrays, filteredCategories };
  };

  const {
    filteredArrays: [
      menApplied,
      menAdmitted,
      womenApplied,
      womenAdmitted,
      otherApplied,
      otherAdmitted,
    ],
    filteredCategories: filteredXAxis,
  } = filterDataWithCategories(
    [
      menAppliedArray,
      menAdmittedArray,
      womenAppliedArray,
      womenAdmittedArray,
      otherAppliedArray,
      otherAdmittedArray,
    ],
    xaxis
  );

  const showOther =
    otherApplied.some((val) => val !== 0) ||
    otherAdmitted.some((val) => val !== 0);

  const yMax =
    Math.max(
      ...menApplied,
      ...menAdmitted,
      ...womenApplied,
      ...womenAdmitted,
      ...(showOther ? [...otherApplied, ...otherAdmitted] : [])
    ) + 5000;

  const series = [
    {
      name: 'Men Applied',
      group: 'Applicants',
      data: menApplied,
    },
    {
      name: 'Men Admits',
      group: 'Admits',
      data: menAdmitted,
    },
    {
      name: 'Women Applied',
      group: 'Applicants',
      data: womenApplied,
    },
    {
      name: 'Women Admits',
      group: 'Admits',
      data: womenAdmitted,
    },
    ...(showOther
      ? [
        {
          name: 'Other Applied',
          group: 'Applicants',
          data: otherApplied,
        },
        {
          name: 'Other Admits',
          group: 'Admits',
          data: otherAdmitted,
        },
      ]
      : []),
  ];

  return (
    <Chart
      options={{
        chart: {
          id: chartId,
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: filteredXAxis,
          labels: {
            show: true,
            rotate: -45,
            style: {
              colors: '#9AA2B6',
            },
          },
        },
        yaxis: {
          min: 0,
          forceNiceScale: true,
          labels: {
            style: {
              colors: ['#9AA2B6'],
            },
            formatter: (val) =>
              val?.toLocaleString('en-US') ?? 'N/A',
          },
        },
        colors: [
          '#90F892',
          '#FFEF68',
          '#C5DEF9',
          '#00E986',
          '#97E6FF',
          '#767676',
        ],
        tooltip: {
          enabled: true,
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#000000'],
          },
          background: {
            enabled: false,
            borderWidth: 0,
            foreColor: '#000',
          },
          formatter: (val) => val?.toLocaleString('en-US') ?? 'N/A',
        },
        legend: {
          show: true,
          onItemClick: {
            toggleDataSeries: false,
          },
          onItemHover: {
            highlightDataSeries: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '75%',
            dataLabels: {
              position: 'top',
              total: {
                enabled: false,
              },
            },
          },
        },
      }}
      series={series}
      type='bar'
      height={'300'}
    />
  );
};

// const GroupStackedColumnChartGender = ({ chartId, xaxis, menAppliedArray, menAdmittedArray, womenAppliedArray, womenAdmittedArray, otherAppliedArray, otherAdmittedArray }) => {

//   const yMax = Math.max(
//     ...menAppliedArray,
//     ...menAdmittedArray,
//     ...womenAppliedArray,
//     ...womenAdmittedArray,
//     ...otherAppliedArray,
//     ...otherAdmittedArray
//   ) + 5000

//   return (
//     <Chart
//       options={{
//         chart: {
//           id: chartId,
//           stacked: true,
//           toolbar: {
//             show: false,
//           },
//         },
//         xaxis: {
//           categories: xaxis,
//           labels: {
//             show: true,
//             rotate: -45,
//             style: {
//               colors: '#9AA2B6',
//             },
//           }
//         },
//         yaxis: {
//           min: 0,
//           //max: yMax,
//           forceNiceScale: true,
//           labels: {
//             style: {
//               colors: ['#9AA2B6'],
//             },
//             formatter: function (val, opts) {
//               return val?.toLocaleString("en-US") ?? 'N/A';
//             },
//           }
//         },
//         colors: ["#90F892", "#FFEF68", "#C5DEF9", "#00E986", "#97E6FF", "767676"],
//         tooltip: {
//           enabled: true,
//         },
//         dataLabels: {
//           enabled: true,
//           style: {
//             colors: ['#000000'],
//           },
//           background: {
//             enabled: false,
//             borderWidth: 0,
//             foreColor: '#000',
//           },
//           formatter: function (val, opts) {
//             return val?.toLocaleString("en-US") ?? 'N/A';
//           },
//         },
//         legend: {
//           show: true,
//           onItemClick: {
//             toggleDataSeries: false
//           },
//           onItemHover: {
//             highlightDataSeries: true
//           },
//         },
//         plotOptions: {
//           bar: {
//             horizontal: false,
//             columnWidth: '75%',
//             dataLabels: {
//               position: 'top',
//               total: {
//                 enabled: false,
//               }
//             },
//           }
//         }
//       }}
//       series={otherAppliedArray.some(item => item != 0) && otherAdmittedArray.some(item => item != 0) ? [
//         {
//           name: 'Men Applied',
//           group: 'Applicants',
//           data: menAppliedArray
//         },
//         {
//           name: 'Men Admits',
//           group: 'Admits',
//           data: menAdmittedArray,
//         },
//         {
//           name: 'Women Applied',
//           group: 'Applicants',
//           data: womenAppliedArray
//         },
//         {
//           name: 'Women Admits',
//           group: 'Admits',
//           data: womenAdmittedArray
//         },
//         {
//           name: 'Other Applied',
//           group: 'Applicants',
//           data: otherAppliedArray
//         },
//         {
//           name: 'Other Admits',
//           group: 'Admits',
//           data: otherAdmittedArray
//         }
//       ] : [
//         {
//           name: 'Men Applied',
//           group: 'Applicants',
//           data: menAppliedArray
//         },
//         {
//           name: 'Men Admits',
//           group: 'Admits',
//           data: menAdmittedArray,
//         },
//         {
//           name: 'Women Applied',
//           group: 'Applicants',
//           data: womenAppliedArray
//         },
//         {
//           name: 'Women Admits',
//           group: 'Admits',
//           data: womenAdmittedArray
//         }
//       ]}
//       type='bar'
//       height={'300'}
//     />
//   )
// }

export {
  GroupStackedColumnChart,
  GroupStackedColumnChartGender
}
